var _defs, _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144.32993164062498px",
    height: "242px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "177.8350341796875 -46 144.32993164062498 242",
    style: {
      background: "rgba(0, 0, 0, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing-gradow-gradient",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6600ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "editing-gradow-filter",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceAlpha",
    in: "flood",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4,
    in: "SourceGraphic",
    result: "offset-1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "shadow",
    result: "offset-2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-1"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-gradow-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.63705778121948, 121.68999671936035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.12-93.38L57.12-93.38L57.12-93.38Q91.42-93.38 91.42-69.16L91.42-69.16L91.42-69.16Q91.42-55.86 82.88-47.88L82.88-47.88L82.88-47.88Q74.48-39.90 59.78-39.90L59.78-39.90L59.78-39.90Q52.92-39.90 47.60-43.82L47.60-43.82L47.60-43.82Q45.08-45.50 43.40-47.74L43.40-47.74L43.40-47.74Q53.62-47.74 59.01-53.97L59.01-53.97L59.01-53.97Q64.40-60.20 64.40-72.38L64.40-72.38L64.40-72.38Q64.40-84.56 52.36-84.56L52.36-84.56L49.00-84.56L49.00-84.56Q48.16-84.56 47.46-84.42L47.46-84.42L31.36 0L0.98 0L18.20-91.70L18.20-91.70Q33.18-93.10 41.86-93.24L41.86-93.24L41.86-93.24Q50.54-93.38 57.12-93.38Z",
    fill: "url(#editing-gradow-gradient)"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text {\n  font-size: 64px;\n  font-family: Arial Black;\n  dominant-baseline: central;\n  text-anchor: middle;\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/P.220e079281707fabe206b99684680aa5.svg";
export { ForwardRef as ReactComponent };